import React from 'react';
import ReactDOM from 'react-dom/client';
import i18n from 'i18next';
import { Box } from '@chakra-ui/react';
import { ModuleRegistry } from '@ag-grid-community/core';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { InfiniteRowModelModule } from '@ag-grid-community/infinite-row-model';
import { initReactI18next } from 'react-i18next';
import { QueryClientProvider } from './providers/query-client-provider';
import { Provider } from '@/components/ui/provider';
import { en } from './i18n/en';
import { es } from './i18n/es';
import './index.css';
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-quartz.css';
import '@fontsource-variable/inter';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { UsersnapProvider } from './providers/usersnap-provider';

export const resources = {
    en,
    es,
};

ModuleRegistry.registerModules([ClientSideRowModelModule, InfiniteRowModelModule]);

i18n.use(initReactI18next).init({
    resources,
    lng: 'en',
    defaultNS: ['COMMON'],
    fallbackNS: 'COMMON',
    interpolation: {
        escapeValue: false,
    },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <Provider>
            <QueryClientProvider>
                <UsersnapProvider>
                    <Box h="100%" w="100%" colorPalette="purple">
                        <RouterProvider router={router} />
                    </Box>
                </UsersnapProvider>
            </QueryClientProvider>
        </Provider>
    </React.StrictMode>,
);
